import { Tooltip, TableBodyCell, AvatarLetter, AvatarWithLabel } from '@pocketlaw/tetris';
export function CreatedByCell(props) {
    const { user } = props;
    const headers = 'filesystemtable-createdBy';
    if (!user) {
        return <TableBodyCell headers={headers}/>;
    }
    const { name, email } = user;
    const text = name || email;
    const initial = text.substring(0, 1).toLocaleUpperCase();
    return (<TableBodyCell headers={headers}>
      <Tooltip title={text}>
        <div>
          <AvatarWithLabel size="md" title={text.split(' ')[0]}>
            <AvatarLetter>{initial}</AvatarLetter>
          </AvatarWithLabel>
        </div>
      </Tooltip>
    </TableBodyCell>);
}
